










































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Period from "@/models/annoucement/period.Model";
@Component
export default class InitperiodAdd extends GenericAdd<Period> {
  constructor() {
    super();
    this.controller = "Periods";
    this.model = new Period();
  }
}
